import React, { useEffect, useRef, useState } from "react"
import "./floating-button.scss"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { siteUrl } from "../../../shared/utils/siteUrl"

export const CurrentFloatingButton = ({ contentInfo }) => {
  const firstImage = contentInfo.botonFlotante.imagenesDeBanner[0].file.url
  const secondImage = contentInfo.botonFlotante.imagenesDeBanner[1].file.url
  const redireccion = contentInfo.botonFlotante.redireccion
  const tag = contentInfo.botonFlotante?.tituloBanner || null
    return (
      <FloatingButton
        url={siteUrl + redireccion}
        tag={tag}
        firstImageUrl={firstImage}
        secondImageUrl={secondImage}
      />
    )
 
}

const FloatingButton = ({
  url,
  tag = "",
  intervalTime = 3000,
  firstImageUrl,
  secondImageUrl
}) => {
  const dom = useRef()
  const [isFirstImage, setIsFirstImage] = useState(true)
  const [showCloseButton, setShowCloseButton] = useState(false)
  const [showFloatingButton, setShowFloatingButton] = useState(true)
  const tageo = () => {
    if (!tag) {
      return
    }
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: "Interacciones_Home",
      category: "floating_button",
      action: "click",
      label: tag,
      location: window.location.href,
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : "",
      log_status: userInfoEncrypt.log_status,
    })
  }
  const redirection = () => {
    tageo()
    window.location.href = url
  }

  useEffect(() => {
    const id = setInterval(() => {
      setIsFirstImage(prev => !prev)
    }, intervalTime || 3000)
    return () => clearInterval(id)

  }, [dom])

  useEffect(() => {
    const id = setInterval(() => {
      setShowCloseButton(true)
    }, 6000)
    return () => clearInterval(id)
  }, [dom])


  const handleCloseButtonClick = () => {
    setShowCloseButton(false)
    setShowFloatingButton(false)
  }


  return (
    showFloatingButton &&
    <>
      <div
        className={"f-floating-button"}
        ref={dom}
        onClick={() => redirection()}
        style={{
          backgroundImage: `url(${isFirstImage ? firstImageUrl : secondImageUrl})`
        }}
      > 
      </div>
      {showCloseButton && (
        <div className="close-button" onClick={handleCloseButtonClick}>
          <span>X</span>
        </div>
      )}
    </>
  )
}
export default FloatingButton
